import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';
import LabelControllers from './LabelControllers';
import AxisControllers from './AxisControllers';
import LegendControllers from './LegendControllers';
import InteractivityController from './InteractivityController';

const Controllers = ({
  config = undefined,
  data = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  selectedLine = undefined,
  selectedColumn = undefined,
  selectedLineMap = undefined,
  selectedColumnMap = undefined,
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
}) => (
  <>
    {[
      GeneralControllers,
      StyleControllers,
      LabelControllers,
      AxisControllers,
      LegendControllers,
      InteractivityController,
    ].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedLine={selectedLine}
        selectedLineMap={selectedLineMap}
        selectedColumn={selectedColumn}
        selectedColumnMap={selectedColumnMap}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.shape({}),
  selectedLineMap: PropTypes.shape({}),
  selectedColumn: PropTypes.shape({}),
  selectedColumnMap: PropTypes.shape({}),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
};

export default Controllers;
